export { default as CarouselShop } from './CarouselShop';